import { useEffect } from 'react'
import { useNovu } from '@novu/react'
import { useQueryClient } from '@tanstack/react-query'
import { applyInvalidation, findNovuInvalidation } from '../../shared/queries/cacheInvalidationGraph'

export type NotificationResult = {
  subject?: string
  body?: string
  data?: Record<string, unknown>
}

type NotificationObject = { type: string }

export const parseObjectType = (raw: unknown): string | null => {
  if (typeof raw !== 'string') return null
  try {
    const parsed = JSON.parse(raw) as NotificationObject
    return typeof parsed.type === 'string' ? parsed.type : null
  } catch {
    return null
  }
}

const useNovuQueryInvalidation = () => {
  const novu = useNovu()
  const queryClient = useQueryClient()

  useEffect(() => {
    // Novu notifies only the saving user, once their 202 background recalculation has finished
    const handleReceived = ({ result }: { result: NotificationResult }) => {
      const invalidation = findNovuInvalidation(parseObjectType(result.data?.object))
      if (!invalidation) return

      applyInvalidation(queryClient, invalidation, { refetchReports: false })
    }

    const cleanup = novu.on('notifications.notification_received', handleReceived)
    return () => {
      cleanup()
    }
  }, [novu, queryClient])
}

export default useNovuQueryInvalidation
